import OurProjectVerticalForm from "../../our-project-vertical/Form";
import { useCommercialDesignProjects } from "../../useHook";

const OurProjectCommercialCreate = () => {
  return (
    <OurProjectVerticalForm
      isEditMode={false}
      useProjectsHook={useCommercialDesignProjects}
      listPath="/our-project-commercial-design"
      subtitle="Commercial construction project"
    />
  );
};

export default OurProjectCommercialCreate;
